"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutServiceBase = void 0;
/**
 * Base abstraction to implement custom layout service
 */
class LayoutServiceBase {
}
exports.LayoutServiceBase = LayoutServiceBase;
